import React, { useState } from "react";
import "./Language_test_step_form.css";

import Step1 from "./step1/Step1";
import Step2 from "./step2/Step2";
import Step3 from "./step3/Step3";
import Step4 from "./step4/Step4";
import Step5 from "./step5/Step5";
import Step6 from "./step6/Step6";
import Step7 from "./step7/Step7";
import Step8 from "./step8/Step8";
import Step9 from "./step9/Step9";
import Step10 from "./step10/Step10";

function Language_test_step_form() {
  const totalSteps = 10;
  const [currentStep, setCurrentStep] = useState(1);

  const handleNext = () => {
    if (currentStep < totalSteps) {
      setCurrentStep((prev) => prev + 1);
    }
  };

  const handleBack = () => {
    if (currentStep > 1) {
      setCurrentStep((prev) => prev - 1);
    }
  };

  const progressPercent = Math.round((currentStep / totalSteps) * 100);

  return (
    <section className="Language_test_step_form">
      {/* Header */}
      <div className="Language_test_step_form_header">
        <div className="heading_text_holder">
          <h1>Language Test</h1>
          <h4>
            Question {currentStep} / {totalSteps}
          </h4>
        </div>

        <div className="alphabet_holder">
          <h1>A1</h1>
        </div>
      </div>

      {/* Progress Bar */}
      <div className="progressbar_holder">
        <div className="d-flex justify-content-between">
          <h2>Progress</h2>
          <h2>{progressPercent}%</h2>
        </div>

        <progress
          className="pregressbar_strick"
          value={progressPercent}
          max="100"
        />
      </div>

      {/* Steps */}
      {currentStep === 1 && <Step1 onNext={handleNext} />}
      {currentStep === 2 && <Step2 onNext={handleNext} onBack={handleBack} />}
      {currentStep === 3 && <Step3 onNext={handleNext} onBack={handleBack} />}
      {currentStep === 4 && <Step4 onNext={handleNext} onBack={handleBack} />}
      {currentStep === 5 && <Step5 onNext={handleNext} onBack={handleBack} />}
      {currentStep === 6 && <Step6 onNext={handleNext} onBack={handleBack} />}
      {currentStep === 7 && <Step7 onNext={handleNext} onBack={handleBack} />}
      {currentStep === 8 && <Step8 onNext={handleNext} onBack={handleBack} />}
      {currentStep === 9 && <Step9 onNext={handleNext} onBack={handleBack} />}
      {currentStep === 10 && <Step10 onBack={handleBack} />}
    </section>
  );
}

export default Language_test_step_form;
